import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const tickets = {
  state: {
    ticket: {},
    tickets: [],
    categories: {},
    class_tickets: [],
    appeal_conversation: [],
  },
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/tickets/store.js